<template>
  <div :id="this.$route.name" :key="Render">
    <card back>
      <template v-slot:header>
        <h4 class="d-inline">{{ title }}({{ $store.state.Grplabel }})</h4>
        <hr />
      </template>
      <template v-slot:content>
        <tab :tab="Tablist">
          <template v-slot:content0>
            <form @submit.prevent="$ValidForm(this)" autocomplete="off">
              <div class="row">
                <div class="col-lg-4 col-12">
                  <small>کد سمت</small>
                  <input @keypress="$ValidNumber($event, 9)" type="text" class="form-control InputText required" v-model="DataAxios.Gcode" />
                </div>
                <div class="col-lg-4 col-12 text-right">
                  <small>نام سمت</small>
                  <input @keypress="$ValidPersian($event, 45)" type="text" class="form-control InputText required" v-model="DataAxios.GName" />
                </div>
                <div class="col-lg-4 col-12 text-right">
                  <small> نام سمت والد </small>
                  <select class="form-control" v-model="DataAxios.ParentId">
                    <option value="-1">نام سمت والد را انتخاب کنید</option>
                    <option v-for="(grp, key) in GrpList" :key="key" :value="grp.id">
                      {{ grp.label }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <small>توضیحات</small>
                  <textarea @keypress="$ValidPersian($event, 95)" type="text" class="form-control" rows="2" v-model="DataAxios.Tozihat"></textarea>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-4 col-12">
                  <small>مدیر کل شعب (بالاترین سطح دسترسی)</small>
                  <span class="form-control p-1">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input InputText" id="IsModirShoab" v-model="IsModir" />
                      <label class="custom-control-label" for="IsModirShoab">مدیر کل شعب</label>
                    </div>
                  </span>
                </div>
                <div class="col-md-8 col-12">
                  <small>نام شعبه</small>
                  <select class="form-control required" id="cmbShobe" v-model="DataAxios.TblShobeId">
                    <option :value="0">نام شعبه را انتخاب کنید</option>
                    <option v-for="item in Listshobe" :key="item.Id" :value="item.Id">
                      {{ item.NameShobe }}
                    </option>
                  </select>
                </div>
              </div>
            </form>
          </template>
          <template v-slot:content1>
            <div class="alert alert-secondary text-center text-danger" v-if="$route.params.Status == 'Add'">این بخش فقط در حالت ویرایش قابل مشاهده می باشد</div>
            <div class="" v-else>
              <div class="row px-3" :key="Render">
                <div class="col-12"><span class="">سمت کاربر برای اتوماسیون ادراری را انتخاب کنید </span></div>
                <div class="col-md-3 col-12 my-2 text-center" v-for="(item, key) in ListGrp105UserRole" :key="key">
                  <div :class="DataAxios.TblComboIdGrpRole322 != null && DataAxios.TblComboIdGrpRole322 == item.id ? 'BoxSelected Pointer' : 'Box Pointer'" @click="SetUserRole(item)">{{ item.name }}</div>
                  <!-- <div @click="SetUserRole(item)">{{ item.name }}</div> -->
                </div>
              </div>
            </div>
          </template>
          <!-- <template v-slot:content1 v-if="$route.params.Status == 'Edit'">
            <div v-if="$route.params.Status == 'Edit'" class="row mt-3">
              <div class="col-md-9 col-12">
                <select id="GrpDb" class="form-control mt-2 mb-4" v-model="GrpDbModel">
                  <option value="-1">
                    <span>سیستم اطلاعاتی برای سمت مورد نظر انتخاب کنید</span>
                  </option>
                  <option :value="item.Id" v-for="item in $store.state.TreeSematha" :id="item.Id" :key="item.Id">
                    <span>{{ item.Dbname }}</span>
                  </option>
                </select>
              </div>
              <div class="col-md-3 col-12">
                <div class="mt-2 mb-3 text-right">
                  <button id="SeveData" type="submit" class="btn btn-success mr-1" dir="ltr" @click.prevent="SetDeta">
                    <span class="mr-2"> ثبت اطلاعات </span>
                    <span class="fa fa fa-check"></span>
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <BnpGrid v-if="$store.state.renderComponentGridModal" :propsColumn="ColumnRiz" :propsRows="rowsRiz"></BnpGrid>
              </div>
            </div>
          </template> -->
        </tab>

        <btn-save-data v-if="$route.params.Status == 'Add'" :DataParanet="DataAxios"></btn-save-data>
        <btn-edit-data v-if="$route.params.Status == 'Edit'" :DataParanet="DataAxios"></btn-edit-data>
      </template>
    </card>
  </div>
</template>
<script>
import BtnSaveData from '@/components/BnpButtons/BtnSaveData.vue'
import BtnEditData from '@/components/BnpButtons/BtnEditData.vue'
import Card from '@/components/Card/Card.vue'
import Tab from '@/components/Tab/Tab.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
export default {
  components: {
    Card,
    BtnSaveData,
    BtnEditData,
    Tab,
    BnpGrid,
  },
  data() {
    return {
      Render: 0,
      ListGrp105UserRole: [],
      DataAxios: {},
      IsModir: false,
      Listshobe: [],
      rowsRiz: [],
      ColumnRiz: [],
      DataAxoisRiz: {
        ArryfildValue: {
          SoftwareId: 2,
          UserId: 1,
          FormName: 'frmDastresiDB',
          ShowView: 0,
        },
        Method: 'post',
        Action: 'ReadGridColumns',
      },
      //   Tablist: [{ header: 'افزودن / ویرایش سمت' }, { header: 'انتخاب سیستم اطلاعاتی' }],
      Tablist: [{ header: 'افزودن / ویرایش سمت' }, { header: 'انتخاب نقش' }],
      InnerDataGetShobe: {
        ArryfildValue: '',
        Method: 'get',
        Action: 'DefineShobe',
        Token: this.$session.get('Token'),
      },
      GrpDbModel: [],
      DataAxiosRow: {
        ArryfildValue: {},
        Method: 'Get',
        Action: 'DastresiDB/GettblDB',
        Token: this.$session.get('Token'),
      },
      RowsGridGrpDb: null,
      DataAxoisCheckedIdDb: {
        ArryfildValue: {},
        Method: 'Get',
        Action: 'DastresiDB',
        Token: this.$session.get('Token'),
        From: 'Header',
      },
      DataAxoisAddTblGrpDb: {
        ArryfildValue: {},
        Method: 'post',
        Action: 'DastresiDB',
        Token: this.$session.get('Token'),
      },
      DataGrpDb: null,
      DataAxios_GetdatRiz: {},
      GrpList: [],
    }
  },
  created() {
    if (this.$route.params.Status == 'Add') {
      this.title = 'افـزودن سمت'
    } else {
      this.GetRoles()
      this.title = 'ویرایش سمت'
    }
  },
  beforeMount() {
    this.$GetData_Body(this.InnerDataGetShobe).then((data) => {
      this.Listshobe = data
    })

    var GetGrp = {
      ArryfildValue: '',
      Method: 'get',
      Action: 'TarifSematha',
      Token: this.$session.get('Token'),
    }
    this.$GetData_Body(GetGrp).then((data) => {
      this.GrpList = data
    })
  },
  mounted() {
    this.GetData()
  },
  methods: {
    SetDeta() {
      var DataGrpDb = this.$store.state.DataGrpDb
      // var DbForAdd = this.$store.state.EditDataTblgrp[0].TblDbid
      for (let index = 0; index < DataGrpDb.length; index++) {
        // console.log(DataGrpDb[index].TblDbid);
        if (this.$store.state.EditDataTblgrp[0].TblDbid == -1) {
          this.$mySweetDefault('عدم امکان ثبت سیستم اطلاعاتی انتخاب شده', 'سیستم اطلاعاتی انتخاب شده ، قبلا برای این سمت ثبت گردیده', 'warning', 3000)
        } else {
          this.DataAxoisAddTblGrpDb.ArryfildValue = this.$store.state.EditDataTblgrp[0]
          this.$PostData(this.DataAxoisAddTblGrpDb).finally(() => {
            this.$mySweetDefaultTost(false, 'بارگزاری یا موفقیت انجام شد', 'success', 2000)
            this.$store.state.renderComponent = false
            this.$store.state.renderComponentGridOneToMeny = false
            this.$nextTick(() => {
              this.$store.state.renderComponent = true
              this.$store.state.renderComponentGridOneToMeny = true
            })
          })
        }
      }
    },
    GetRoles() {
      let DataAxios_SetData = {
        ArryfildValue: { Id: 322, Usergrp: null },
        Method: 'post',
        Action: 'TblCrmCombo/GetComboById',
      }
      this.$PostData(DataAxios_SetData).then((data) => {
        this.ListGrp105UserRole = data
      })
    },
    SetUserRole(row) {
      var formData = new FormData()
      formData.append('tblSematId', this.DataAxios.id)
      formData.append('tblcomboGrpId322UserRole', row.id)
      var DataAxios = { Method: 'POST', Action: 'TarifSematha/SetRole', ArryfildValue: null }
      DataAxios.ArryfildValue = formData
      this.$PostFormData(DataAxios).then((res) => {
        if (res) {
          if (res == false) {
          } else {
            this.DataAxios = res
            this.$toasted.success(' تغیرات در نقش کاربر با موفقیت ثبت شد ', { duration: 3000 })
            // this.GetRoles()
            // this.GetData()
            // this.Render++
            this.$router.go(-1)
          }
        }
      })
    },
    GetData() {
      this.DataAxios.ParentId = this.$store.state.TblGrpId
      if (this.Listshobe.length == 1) {
        var element = document.getElementById('cmbShobe')
        this.DataAxios.TblShobeId = element.options[1].value
      }

      if (this.$route.params.Status == 'Edit') {
        this.GrpDbModel = this.$store.state.DataPostTblGrpDb
        this.DataAxios = this.$store.state.EditDataTblgrp[0]
        this.$store.state.tblgrpid = this.DataAxios.id
        this.$store.state.OldDataForLog = JSON.stringify(this.DataAxios)

        this.$GetData_Body(this.DataAxiosRow)
          .then((data) => {
            this.RowsGridGrpDb = data
          })
          .finally(() => {
            this.$store.state.TreeSematha = this.RowsGridGrpDb
            this.DataAxoisCheckedIdDb.ArryfildValue['Id'] = this.$store.state.EditDataTblgrp[0].id

            this.$GetData_Header(this.DataAxoisCheckedIdDb)
              .then((data) => {
                this.DataGrpDb = data
              })
              .finally(() => {
                this.$store.state.DataGrpDb = this.DataGrpDb
              })
          })
      }
      this.$GetColumns(this.DataAxoisRiz, true)
        .then((data) => {
          this.ColumnRiz = data
        })
        .finally(() => {
          this.$store.state.renderComponentGridModal = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGridModal = true
          })

          this.DataAxios_GetdatRiz.Action = 'DastresiDB/GettblDB'
          this.DataAxios_GetdatRiz.ArryfildValue = {}
          this.DataAxios_GetdatRiz.Method = 'Get'
          ;(this.DataAxios_GetdatRiz.Token = this.$session.get('Token')),
            this.$PostData(this.DataAxios_GetdatRiz)
              .then((data) => {
                if (data.length > 0) {
                  this.rowsRiz = data
                } else {
                  console.log('No Data')
                }
              })
              .finally(() => {
                this.$store.state.renderComponentGridModal = false
                this.$nextTick(() => {
                  this.$store.state.renderComponentGridModal = true
                })
              })
        })
    },
  },
}
</script>
<style scoped>
.Box {
  border: 2px dashed var(--sidebar-color-item);
  padding: 2% !important;
  border-radius: 5px;
}
.BoxSelected {
  /* border: 2px dashed #caa501; */
  background: #18b0c4;
  padding: 2% !important;
  border-radius: 5px;
}
</style>
